import * as React from "react"
import { Box } from "@mui/material"

import { HierarchicalTextBlock, ImageSkuBlock } from "@components"


export default function productIDColumn() {
    return [{
        name: "productID", label: "Product ID",
        options: {
            display: "excluded",
            filterType: "textField"
        }
    }, {
        name: "skuName", label: "SKU",
        options: {
            display: "excluded",
            filterType: "textField"
        }
    }, {
        name: "skuName", label: "Product SKU",
        options: {
            filter: false,
            customBodyRowRender: (value, row) => <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
                gap={2}
            >
                <Box>
                    <ImageSkuBlock imageURL={row.thumbnail} />
                </Box>
                <Box display="flex" flexDirection="column">
                    <HierarchicalTextBlock
                        supertitle="SKU: "
                        supertitleValue={value}
                        title="Product ID: "
                        titleValue={row.productID}
                    />
                </Box>
            </Box>
        }
    }]
}